import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { oneformBFFNdpsSend } from 'src/bff';
import { FormController, useOneFormContext } from 'src/feature-app';
import { getParamsForm } from 'src/feature-app/get-params-form';
import { CemFormProps } from 'src/forms/Cem';
import {
	checkUndefinedsInData,
	formatSinRespuestaValue,
	getCemDate,
	getSfAddressRest,
	sanitizeKvps,
	valueWrongConcesion,
	valueWrongMarca,
	valueWrongModelo,
	valueWrongPersona,
} from 'src/forms/Cem/helpers';
import { ThankYouCEM } from 'src/forms/Cem/ThankYouCem';
import { formatHeaders, formDataBuilder } from 'src/forms/format-fields';
import {
	getIndexInSteps,
	removeMultipleStepsAndResetScreenIndex,
	resetStepsScreenIndex,
} from 'src/forms/helpers/add-remove-steps';
import { formatToTwoChars } from 'src/helpers';
import { FormDataGroup, FormInfo, OneFormState, Steps } from 'src/types';
import {
	addStepsCEM,
	getActionShowMotivoCEM,
	lastQuestionFlow,
	removeAndAddStepAtTheSameTimeCEM,
	removeStepsCEM,
	shuffleCEM,
	updateStepsCEM,
} from '../helpers/steps';
import { getCemCarlineName, getCemInstallationName } from '../helpers/utils';
import { getStepsPosventa } from './CemStepsPosventa';

export function CemFormPosventa(props: CemFormProps) {
	const { idOrder, idPerson, idVehicle, idDealer, dpsData, installation } =
		props;
	const { initializeForm, handleNextStep } = useOneFormContext();
	const { formData } = useSelector((state: OneFormState) => state);
	const store = useStore();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);

	const urlParams = new URLSearchParams(window.location.search);
	const dev = urlParams.get('dev') !== null;

	const {
		datosCorrectos,
		datosIncorrectos,
		satisfaccionTrato,
		satisfaccionOrganizacion,
		satisfaccionTrabajoRealizado,
		satisfaccionConcesion,
		enviarConcesion,
		servicioAnteriorIncorrecto,
		razonVolverTaller,
	} = formData.fields;

	//////////////////////////
	// DATA
	//////////////////////////

	const NuevoFormData: Partial<FormDataGroup> = {
		headers: {
			FORM_DETAILS: 'CEM Posventa',
			FORM_OBJECTIVE: 'Encuesta',
			DPS_TOKEN: 'VW_DDB_FRM_CEM_PV_2025',
			FORM_ID: 'Email_B04_C01_CEM_Aftersales',
		},
		fields: {
			lssiPincode: idPerson.LSSI__c,
			formName: 'cem-posventa',
			formType: 'otherform',
			pageCategory: 'Encuesta',
			name: idPerson.FirstName,
			surname: idPerson.LastName,
			secondSurname: idPerson.MiddleName,
			installation: getCemInstallationName(installation, idDealer),
		}, // Analítica
	};

	const sendSurvey = () => {
		const { formData }: OneFormState = store.getState();
		const { fields } = formData;

		return !(
			// negation
			(
				(fields.datosCorrectos == 'false' &&
					fields.datosIncorrectos == valueWrongMarca) ||
				(fields.datosCorrectos == 'false' &&
					fields.datosIncorrectos == valueWrongPersona) ||
				(fields.datosCorrectos == 'false' &&
					fields.datosIncorrectos == valueWrongConcesion)
			)
		);
	};

	const getData = (addSurvey?: boolean) => {
		const { formData }: OneFormState = store.getState();
		const { fields, headers } = formData;
		const { tc, today, url, device } = getParamsForm();

		const data = {
			...formatHeaders(headers),
			'headers[FORM_NAME]': `vw-oneform-${fields.formName}`,
			'headers[FORM_VERSION]': '1',
			'headers[FORM_URL]': url,
			'headers[FORM_DATE_INSERTION]': today,
			'headers[ORIGIN_DEVICE_TYPE]': device,
			'headers[ORIGIN_TRACKING_CODE]': tc,
			'headers[PINCODE]': dpsData.pincode.pincodeResponse.params.pincode,
			'headers[FK_SYSTEM]': dpsData.or,

			'fields[DPS_BRAND]': 'Volkswagen',
			//'fields[SF_LEAD_INSTALLATION_ID]': installation.Id,
			'fields[SF_LEAD_INSTALLATION_NAME]':
				installation.VGED_CommercialName__c,
			'fields[SF_LEAD_INSTALLATION_CODE]':
				installation.VGED_DealerCode__c,
			'fields[SF_LEAD_INSTALLATION_CODE_KVPS]': sanitizeKvps(
				installation.KVPSCode__c,
			),
			'fields[PERSON_RGPD_PERFILADO]': fields.tmk
				? fields.tmk
				: 'NO INFORMADO',
			'fields[PERSON_RGPD_COM_COMERCIALES]': fields.lssi
				? fields.lssi
				: 'NO INFORMADO',
			'fields[PERSON_NAME]': fields.name,
			'fields[PERSON_SURNAME_1]': fields.surname,
			'fields[PERSON_SURNAME_2]': fields.secondSurname,
			'fields[PERSON_EMAIL]': idPerson.PersonEmail,
			'fields[PERSON_PHONE_MOBILE]': idPerson.PersonMobilePhone,
			'fields[PERSON_POSTAL_ROAD_NAME]': getSfAddressRest(
				idPerson.PersonMailingAddress,
				'street',
			),
			'fields[PERSON_POSTAL_CP]': getSfAddressRest(
				idPerson.PersonMailingAddress,
				'postalCode',
			),
			'fields[PERSON_POSTAL_LOCATION]': getSfAddressRest(
				idPerson?.PersonMailingAddress,
				'city',
			),
			'fields[PERSON_POSTAL_PROVINCE_CODE]': formatToTwoChars(
				getSfAddressRest(idPerson.PersonMailingAddress, 'stateCode'),
			),
			'fields[VEH_ACTUAL_PLATE]': idVehicle.VGED_RegistrationPlate__c,
			'fields[VEH_ACTUAL_FRAME]': idVehicle.Name,
			'fields[VEH_ACTUAL_MODEL]': idVehicle.VGED_ModelGroup__c
				? idVehicle.VGED_ModelGroup__c
				: dpsData.model
				? dpsData.model
				: null,

			'fields[SURVEY_ANSWER_01]':
				fields.datosCorrectos == 'true' ? '1' : '2',
			'fields[SURVEY_ANSWER_02]':
				fields.datosCorrectos == 'false'
					? fields.datosIncorrectos
					: null,
			'fields[SURVEY_ANSWER_03]':
				fields.datosCorrectos == 'false' && fields.datosIncorrectos == 2
					? fields.modelo
					: null,
			// conditional send
			'fields[SURVEY_ANSWER_30]': fields.publicarRespuestas,
			'fields[SURVEY_ANSWER_32]': dpsData.adviser,
			'fields[SURVEY_ANSWER_34]': fields.enviarConcesion,

			'flags[PERSON_RGPD_ADAPTED]': 'true',
			//'flags[FLAG_RELACION_MARCA_SIN_IC]': 'false',
		};

		if (sendSurvey() || addSurvey) {
			data['fields[SURVEY_ANSWER_06]'] = formatSinRespuestaValue(
				fields.satisfaccionTrato,
			);
			data['fields[SURVEY_ANSWER_07]'] = formatSinRespuestaValue(
				fields.satisfaccionTratoMotivo,
			);
			data['fields[SURVEY_ANSWER_08]'] = formatSinRespuestaValue(
				fields.satisfaccionOrganizacion,
			);
			data['fields[SURVEY_ANSWER_09]'] = formatSinRespuestaValue(
				fields.satisfaccionOrganizacionMotivo,
			);
			data['fields[SURVEY_ANSWER_10]'] = formatSinRespuestaValue(
				fields.satisfaccionTrabajoRealizado,
			);
			data['fields[SURVEY_ANSWER_11]'] = formatSinRespuestaValue(
				fields.satisfaccionTrabajoRealizadoMotivo,
			);

			if (
				isTrabajoRealizadoIncompleto(
					fields.satisfaccionTrabajoRealizado,
				)
			) {
				data['fields[SURVEY_ANSWER_16]'] =
					fields.servicioAnteriorIncorrecto;
				data['fields[SURVEY_ANSWER_04]'] = fields.razonVolverTaller;
				data['fields[SURVEY_ANSWER_21]'] =
					fields.razonVolverTaller == '10'
						? fields.razonVolverTallerDetalle
						: '';
			}

			data['fields[SURVEY_ANSWER_12]'] = formatSinRespuestaValue(
				fields.satisfaccionConcesion,
			);
			data['fields[SURVEY_ANSWER_13]'] = formatSinRespuestaValue(
				fields.satisfaccionConcesionMotivo,
			);
			data['fields[SURVEY_ANSWER_14]'] = formatSinRespuestaValue(
				fields.aspectoSatisfaccionMotivo,
			);
			data['fields[SURVEY_ANSWER_15]'] = fields.contactoSatisfaccion;

			data['fields[SURVEY_ANSWER_17]'] = formatSinRespuestaValue(
				fields.tiempoSatisfaccion,
			);
			data['fields[SURVEY_ANSWER_18]'] = !fields.motivosVisita
				? '99'
				: fields.motivosVisita
						?.split(',')
						.sort((a, b) => a - b)
						.join('|');
			data['fields[SURVEY_ANSWER_19]'] = formatSinRespuestaValue(
				fields.satisfaccionVehiculo,
			);
			data['fields[SURVEY_ANSWER_20]'] = formatSinRespuestaValue(
				fields.satisfaccionVehiculoMotivo,
			);
		}

		if (dpsData.dat) {
			data['fields[CEM_DATE]'] = getCemDate(dpsData.dat);
		}

		return data;
	};

	useEffect(() => {
		if (dev) {
			console.log(getData(true));
		}
	}, [formData]);

	const sendForm = (): Promise<boolean> => {
		return new Promise<any>(async (resolve, reject) => {
			const dataStringified = JSON.stringify(getData());
			const dataParsed = JSON.parse(dataStringified);
			const formData = formDataBuilder(dataParsed);
			checkUndefinedsInData(getData(), 'Posventa');
			const response = await oneformBFFNdpsSend(formData);

			if (response?.data?.status?.code == 200) {
				dispatch({ type: 'SET_FORM_RESPONSE', payload: response.data });
				resolve(true);
			} else {
				resolve(false);
			}
		});
	};

	//////////////////////////
	// STEPS
	//////////////////////////

	const [initialSteps, setInitialSteps] = useState(
		getStepsPosventa(
			getCemInstallationName(installation, idDealer),
			getCemCarlineName(idVehicle, formData.fields, dpsData),
		),
	);

	useEffect(() => {
		const newSteps = getStepsPosventa(
			getCemInstallationName(installation, idDealer),
			getCemCarlineName(idVehicle, formData.fields, dpsData),
		);
		setInitialSteps(newSteps);

		// Reinicializar el formulario si ya está iniciado
		const currentFormInfo = store.getState().formInfo;
		if (currentFormInfo?.formStarted) {
			const { newSteps: randomizedSteps } = getFormInfo(newSteps);

			const updatedFormInfo: Partial<FormInfo> = {
				...currentFormInfo,
				steps: randomizedSteps,
				initialSteps: newSteps,
			};

			dispatch({ type: 'SET_FORM_INFO', payload: updatedFormInfo });
		}
	}, [installation, idDealer, idVehicle, dpsData, formData.fields.modelo]);

	const isTrabajoRealizadoIncompleto = (rating: string | number | Number) => {
		return [1, 2, 3, 4].includes(Number(rating));
	};

	const getOrderStep = (
		order: number,
		sc4: number,
		sc5: number,
		sc6: number,
	) => {
		return order === 1 ? sc4 : order === 2 ? sc5 : order === 3 ? sc6 : null;
	};

	/**
	 * El orden de las preguntas Sc_4,Sc_5 y Sc_6 tiene que ser aleatorio.
	 * @param steps
	 */
	const randomizeSteps = (steps: Steps[]): Steps[] => {
		const sc4 = getIndexInSteps(steps, 'SatisfaccionTrato');
		const sc4Motivo = getIndexInSteps(steps, 'SatisfaccionTratoMotivo');

		const sc5 = getIndexInSteps(steps, 'SatisfaccionOrganizacion');
		const sc5Motivo = getIndexInSteps(
			steps,
			'SatisfaccionOrganizacionMotivo',
		);

		const sc6 = getIndexInSteps(steps, 'SatisfaccionTrabajoRealizado');
		const sc6Motivo = getIndexInSteps(
			steps,
			'SatisfaccionTrabajoRealizadoMotivo',
		);

		const newSteps = [...steps];
		const [first, second, third] = shuffleCEM([1, 2, 3]);
		const firstStep = getOrderStep(first, sc4, sc5, sc6);
		const secondStep = getOrderStep(second, sc4, sc5, sc6);
		const thirdStep = getOrderStep(third, sc4, sc5, sc6);
		newSteps[sc4] = steps[firstStep];
		newSteps[sc4Motivo] = steps[firstStep + 1];
		newSteps[sc5] = steps[secondStep];
		newSteps[sc5Motivo] = steps[secondStep + 1];
		newSteps[sc6] = steps[thirdStep];
		newSteps[sc6Motivo] = steps[thirdStep + 1];
		return newSteps;
	};

	useEffect(() => {
		if (datosCorrectos === 'true') {
			const steps = store.getState().formInfo.steps;
			const modelo = getIndexInSteps(steps, 'Modelo');
			// En el caso de elegir que los datos son incorrectos, llegar a confirmación y volver atrás hay que regenerar todos los pasos.
			if (modelo === -1) {
				const initialSteps = store.getState().formInfo.initialSteps;
				const finalSteps = removeMultipleStepsAndResetScreenIndex(
					initialSteps,
					['DatosIncorrectos', 'Modelo'],
				);
				updateStepsCEM(finalSteps, dispatch);
			} else {
				removeStepsCEM(
					['DatosIncorrectos', 'Modelo', 'ConfirmacionConcesion'],
					dispatch,
				);
			}
		} else if (datosCorrectos === 'false') {
			addStepsCEM(
				initialSteps,
				['DatosIncorrectos', 'Modelo'],
				dispatch,
				handleNextStep,
			);
		}
	}, [datosCorrectos]);

	useEffect(() => {
		if (
			datosIncorrectos == valueWrongMarca ||
			datosIncorrectos == valueWrongConcesion ||
			datosIncorrectos == valueWrongPersona
		) {
			const pastSteps = store.getState().formInfo.steps;
			const newsteps = [
				pastSteps[0],
				pastSteps[1],
				pastSteps[pastSteps.length - 1],
			];
			const finalSteps = resetStepsScreenIndex(newsteps);
			updateStepsCEM(finalSteps, dispatch);
		}
		if (datosIncorrectos == valueWrongModelo) {
			const initialSteps = store.getState().formInfo.initialSteps;
			const finalSteps = resetStepsScreenIndex(initialSteps);
			updateStepsCEM(finalSteps, dispatch);
		}
	}, [datosIncorrectos]);

	useEffect(() => {
		if (!enviarConcesion) {
			return;
		}
		if (enviarConcesion === '3') {
			addStepsCEM(
				initialSteps,
				['DatosPersonales'],
				dispatch,
				handleNextStep,
			);
		} else {
			removeStepsCEM(['DatosPersonales'], dispatch);
		}
	}, [enviarConcesion]);

	useEffect(() => {
		if (!servicioAnteriorIncorrecto) {
			return;
		}

		if (servicioAnteriorIncorrecto == '3') {
			addStepsCEM(
				initialSteps,
				['RazonVolverTaller', 'RazonVolverTallerDetalle'],
				dispatch,
				handleNextStep,
			);
		} else {
			removeStepsCEM(
				['RazonVolverTaller', 'RazonVolverTallerDetalle'],
				dispatch,
			);
		}
	}, [servicioAnteriorIncorrecto]);

	useEffect(() => {
		if (!razonVolverTaller) {
			return;
		}

		if (razonVolverTaller == '10') {
			addStepsCEM(
				initialSteps,
				['RazonVolverTallerDetalle'],
				dispatch,
				handleNextStep,
			);
		} else {
			removeStepsCEM(['RazonVolverTallerDetalle'], dispatch);
		}
	}, [razonVolverTaller]);

	useEffect(() => {
		const tratoResult = getActionShowMotivoCEM(
			'SatisfaccionTratoMotivo',
			satisfaccionTrato,
		);
		if (tratoResult?.action === 'add') {
			addStepsCEM(
				initialSteps,
				tratoResult.steps,
				dispatch,
				handleNextStep,
			);
		} else if (tratoResult?.action === 'remove') {
			removeStepsCEM(tratoResult.steps, dispatch);
		}
	}, [satisfaccionTrato]);

	useEffect(() => {
		const organizacionResult = getActionShowMotivoCEM(
			'SatisfaccionOrganizacionMotivo',
			satisfaccionOrganizacion,
		);
		if (organizacionResult?.action === 'add') {
			addStepsCEM(
				initialSteps,
				organizacionResult.steps,
				dispatch,
				handleNextStep,
			);
		} else if (organizacionResult?.action === 'remove') {
			removeStepsCEM(organizacionResult.steps, dispatch);
		}
	}, [satisfaccionOrganizacion]);

	useEffect(() => {
		if (!satisfaccionTrabajoRealizado) {
			return;
		}

		if (isTrabajoRealizadoIncompleto(satisfaccionTrabajoRealizado)) {
			addStepsCEM(
				initialSteps,
				[
					'ServicioAnteriorIncorrecto',
					'RazonVolverTaller',
					'RazonVolverTallerDetalle',
				],
				dispatch,
				handleNextStep,
			);
		} else {
			removeStepsCEM(
				[
					'ServicioAnteriorIncorrecto',
					'RazonVolverTaller',
					'RazonVolverTallerDetalle',
				],
				dispatch,
			);
		}

		const trabajoResult = getActionShowMotivoCEM(
			'SatisfaccionTrabajoRealizadoMotivo',
			satisfaccionTrabajoRealizado,
		);
		if (trabajoResult?.action === 'add') {
			addStepsCEM(
				initialSteps,
				trabajoResult.steps,
				dispatch,
				handleNextStep,
			);
		} else if (trabajoResult?.action === 'remove') {
			removeStepsCEM(trabajoResult.steps, dispatch);
		}
	}, [satisfaccionTrabajoRealizado]);

	useEffect(() => {
		const stepName = store.getState().formInfo?.step?.name;

		// Verificamos que se ha contestado SatisfaccionConcesion
		if (stepName == 'SatisfaccionConcesion') {
			const ratings = [
				satisfaccionTrato,
				satisfaccionOrganizacion,
				satisfaccionTrabajoRealizado,
			];
			const { mostrarQlast1, mostrarQlast2 } = lastQuestionFlow(
				ratings,
				satisfaccionConcesion,
			);

			if (mostrarQlast1 && mostrarQlast2) {
				addStepsCEM(
					initialSteps,
					[
						'SatisfaccionConcesionMotivo',
						'AspectoSatisfaccionMotivo',
					],
					dispatch,
					handleNextStep,
				);
			}
			if (!mostrarQlast1 && !mostrarQlast2) {
				removeStepsCEM(
					[
						'SatisfaccionConcesionMotivo',
						'AspectoSatisfaccionMotivo',
					],
					dispatch,
				);
				delete formData.fields.satisfaccionConcesionMotivo;
				delete formData.fields.aspectoSatisfaccionMotivo;
			}
			if (!mostrarQlast1 && mostrarQlast2) {
				removeAndAddStepAtTheSameTimeCEM(
					initialSteps,
					'SatisfaccionConcesionMotivo',
					'AspectoSatisfaccionMotivo',
					dispatch,
					handleNextStep,
				);
				delete formData.fields.satisfaccionConcesionMotivo;
			}
			if (mostrarQlast1 && !mostrarQlast2) {
				removeAndAddStepAtTheSameTimeCEM(
					initialSteps,
					'AspectoSatisfaccionMotivo',
					'SatisfaccionConcesionMotivo',
					dispatch,
					handleNextStep,
				);
				delete formData.fields.aspectoSatisfaccionMotivo;
			}
		}
	}, [
		satisfaccionTrato,
		satisfaccionOrganizacion,
		satisfaccionTrabajoRealizado,
		satisfaccionConcesion,
	]);

	//////////////////////////
	// FORM
	//////////////////////////

	const getFormInfo = (steps: Steps[]) => {
		const randomizedSteps = randomizeSteps(steps);

		return {
			firstStep: randomizedSteps[0],
			lastStep: randomizedSteps[randomizedSteps.length - 1],
			stepsHistory: [0],
			numberOfScreens: randomizedSteps.length,
			newSteps: randomizedSteps,
		};
	};

	useEffect(() => {
		if (!installation) return null;

		const { firstStep, lastStep, stepsHistory, numberOfScreens, newSteps } =
			getFormInfo(initialSteps);

		const NuevoFormInfo: Partial<FormInfo> = {
			formStarted: true,
			sendFormCallback: sendForm,
			fullScreen: firstStep.fullScreen ? true : false,
			lastStep,
			numberOfScreens,
			formTheme: 'main',
			notALayer: true,
			formType: 'inPage',
			screenIndex: firstStep.screenIndex,
			step: firstStep,
			steps: newSteps ? newSteps : initialSteps,
			stepsHistory,
			thankYouComponent: <ThankYouCEM />,
			hideLegal: true, // Ocultamos default legales y añadimos custom legales en Confirmacion,
		};

		initializeForm(NuevoFormInfo, NuevoFormData);
	}, [installation]);

	return !loading ? (
		<FormController steps={initialSteps} screenType="full-screen" />
	) : null;
}
